import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import Home from './pages/Home';
import Learn from './pages/Learn';
import Explore from './pages/Explore';
import Quiz from './pages/Quiz';
import CatchUpChallenge from './pages/CatchUpChallenge';
import Dashboard from './pages/Dashboard';
import Sandbox from './pages/Sandbox';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import UnlockPremium from './pages/UnlockPremium';
import LoginPage from './pages/LoginPage';
import AuthCallback from './pages/AuthCallback';
import ContactPage from './pages/ContactPage';

function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id (from Emergent OAuth)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/learn" element={<Learn />} />
      <Route path="/learn/:orbitId" element={<Learn />} />
      <Route path="/explore" element={<Explore />} />
      <Route path="/quiz" element={<Quiz />} />
      <Route path="/quiz/:orbitId" element={<Quiz />} />
      <Route path="/challenge" element={<CatchUpChallenge />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/sandbox" element={<Sandbox />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/unlock-premium" element={<UnlockPremium />} />
      <Route path="/contact" element={<ContactPage />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <AppRouter />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
